import { Box } from "@mui/system";
import React from "react";
import useDashboardWidgetStyles from "./DashboardWidget.styles";

export interface DashboardWidgetProps {
    children: any;
    widgetCardShadow?: boolean;
    widgetCardHeader: string;
    headerActions?: React.ReactNode;
}

function DashboardWidget(props: DashboardWidgetProps) {
    const classes = useDashboardWidgetStyles({ widgetCardShadow: props.widgetCardShadow });
    return (
        <Box sx={() => ({ height: "100%" })}>
            <div className={classes.headerRow}>
                <h3 className={classes.header}>{props.widgetCardHeader}</h3>
            </div>
            <Box className={classes.card}>
                {props.headerActions && <div className={classes.cardActions}>{props.headerActions}</div>}
                {props.children}
            </Box>
        </Box>
    );
}

export default DashboardWidget;
